<template>
	<c-modal @close="close" :title="'Offerte mailen'">
		<div>
			<p class="margin-t-32">Naar welke contactpersoon wil je de offerte mailen?</p>


            <c-select v-if="contacts"
				:label="'Contactpersoon'"
				:horizontal="true"
				:options="contacts"
				v-model="contact"
				:ValueName="'id'"
                :DisplayName="'first_name,last_name'"
				name="contact"
				:required="true">
			</c-select>

			<c-button class="c-btn c-btn no-margin-b margin-r-32" @click="mail()">
				Offerte mailen
			</c-button>

			<c-button class="c-btn--hollow no-margin-b" @click="close()">
				Sluiten
			</c-button>
		</div>
	</c-modal>
</template>

<script>
import CModal from '@components/Modal';
import Form from '@mixins/Form';

export default {
	mixins: [Form],
	components: {
		CModal
	},
	props: {
		contacts: {
			required: false
		}
	},
	data() {
		return {
			text: '',
			cantDelete: false,
            contact: '',
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
        mail(){
            this.$emit('mail', this.contact);
        }
	}
}
</script>